import { veeFormFieldHOC } from '@/kasten-components/components/KaVeeFormField';

import { default as KaRangeSlider } from './KaRangeSlider.vue';

export { type KaRangeSliderProps } from './KaRangeSlider.vue';

export const KaRangeSliderVee = veeFormFieldHOC(KaRangeSlider);

export { KaRangeSlider };
